import { Component, inject, Inject, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-mdl-manage-contract',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule],
  templateUrl: './mdl-manage-contract.html',
  styleUrls: ['./mdl-manage-contract.css'],
})
export class MdlmanageContract implements OnInit {
  private api = inject(Api);
  archivoTouched = false;


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public mdl: MatDialogRef<MdlmanageContract>
  ) {}

  private alertService = inject(AlertService);
  public contrato: any = {};
  public request: any = {
    numero_contrato: '',
    tipo: '',
    archivo_url: '',
    estado: '',
    fecha_inicio: '',
    duracion_meses: 0,
    monto: 0,
    monto_mensual: 0,
    moneda: '',
    oportunidad_id: '',
    observaciones: '',
    recordatorio_valor: 30,
    recordatorio_unidad: 'dias',
    orden_compra: '',
  };

  public oportunidades: any = [];

  ngOnInit(): void {
    this.cargarOportunidades();

    if (this.data.mode === 'edit') {
      this.contrato = this.data.contrato;
      this.request.contrato_id = this.contrato.contrato_id;
      this.request.numero_contrato = this.contrato.numero_contrato || '';
      this.request.tipo = this.contrato.tipo || '';
      this.request.archivo_url = this.contrato.archivo_url || '';
      this.request.estado = this.contrato.estado || '';
      this.request.fecha_inicio = this.contrato.fecha_inicio || '';
      this.request.duracion_meses = this.contrato.duracion_meses || 0;
      this.request.monto = this.contrato.monto || 0;
      this.request.monto_mensual = this.contrato.monto_mensual || 0;
      this.request.moneda = this.contrato.moneda || '';
      this.request.oportunidad_id = this.contrato.oportunidad_id || '';
      this.request.observaciones = this.contrato.observaciones || '';
      this.request.orden_compra = this.contrato.orden_compra || '';
      this.request.recordatorio_valor = this.contrato.recordatorio_valor || 30;
      this.request.recordatorio_unidad = this.contrato.recordatorio_unidad || 'dias';
      this.selectedRecordatorio = {
        valor: this.request.recordatorio_valor,
        unidad: this.request.recordatorio_unidad,
      };
    } else {
      this.generarNumeroContrato();
    }
  }

  generarNumeroContrato() {
    this.api.getNextContractNumber().subscribe({
      next: (res: any) => {
        this.request.numero_contrato = res.numero_contrato;
      },
      error: (err) => console.error('Error generando número contrato:', err),
    });
  }

  calcularMontoMensual(): void {
    const monto = Number(this.request.monto);
    const duracion = Number(this.request.duracion_meses);

    if (monto > 0 && duracion > 0) {
      this.request.monto_mensual = (monto / duracion).toFixed(2);
    } else {
      this.request.monto_mensual = '';
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  createContract() {
    this.api.showLoading();
    try {
      this.api.createContract(this.request).subscribe({
        next: (data: any) => {
          setTimeout(() => {
            this.api.hideLoading();
            window.location.reload();
          }, 500);
        },
        error: (err: any) => {
          this.api.hideLoading();
          if (err?.status===403){
          this.alertService.error('Acceso denegado',"No tienes permiso para crear contratos.");
          this.mdl.close(false);
          return
          }
        this.alertService.error('Error','Ocurrió un problema al crear el contrato.')
        this.mdl.close(false);
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  updateContract() {
    try {
      this.api.updateContract(this.request).subscribe({
        next: (data: any) => {
          console.log(data);
          setTimeout(() => {
            this.api.hideLoading();
            window.location.reload();
          }, 500);
        },
        error: (err: any) => {
        this.api.hideLoading();
        if (err?.status===403){
          this.alertService.error('Acceso denegado',"No tienes permiso para modificar contratos.");
          this.mdl.close(false);
          return
        }
        this.alertService.error('Error','Ocurrió un problema al modificar el contrato.')
        this.mdl.close(false);
        },
      });
    } catch (error) {
      console.error(error);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.request.archivo_url = input.files[0].name;
    }
  }

  selectedRecordatorio: { valor: number; unidad: string } | null = null;

  onRecordatorioChange() {
    if (this.selectedRecordatorio) {
      this.request.recordatorio_valor = this.selectedRecordatorio.valor;
      this.request.recordatorio_unidad = this.selectedRecordatorio.unidad;
    }
  }

  cargarOportunidades() {
    this.api.getOpportunities().subscribe({
      next: (response: any) => {
        if (Array.isArray(response.oportunidades)) {
          this.oportunidades = response.oportunidades;
        } else if (Array.isArray(response)) {
          this.oportunidades = response;
        } else {
          console.warn(
            'Formato inesperado en la respuesta del backend:',
            response
          );
        }
      },
      error: (err: any) => {
        console.error('Error al cargar oportunidades:', err);
      },
    });
  }
}
